@if (active$ | async) {
  <div class="oab-progress" role="progressbar" aria-label="Carregando">
    <div class="oab-progress__bar"></div>
  </div>
}
